module.exports = __webpack_public_path__ + "static/media/Yoyo_5521.2f95f49f.jpg";